
















import {State, Getter, Action, namespace} from 'vuex-class'
import {Vue, Prop, Component, Watch} from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {IPermission} from '@/store/modules/views/permission/states'
import {RolePermissionList} from '@/store/modules/views/role/states'

@Component
export default class EditPermissionDialog extends VueExtendedBaseComponent {

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editPermissionAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get isAdmin() {
    if (this.profileRole === 'ผู้ดูแลระบบ') {
      return true
    } else {
      return false
    }
  }

  get permissionList() {
    return this.PermissionList
  }

  @Getter('userprofile/getProfile')
  private profile!: any

  get rolePermissionList() {
    return this.RolePermissionList
  }

  get userProfile() {
    return this.profile
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private permission!: { _id: string, name: string }
  private loading = false
  private name = ''
  private permissionId = ''
  private isRequireCenter = false
  private profileRole = ''

  @Action('permission/GetPermission')
  private getPermissionList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('permission/itemLists')
  private PermissionList!: IPermission['result']

  @Getter('role/rolePermissionList')
  private RolePermissionList!: RolePermissionList[]


  private options = {
    page: 1,
    sortBy: 'key',
    sortDesc: false,
    itemsPerPage: 1000,
    search: '',
  }

  public async created() {
    this.name = this.permission.name || null
    this.permissionId = this.permission._id || null

  }

  private async editPermissionAction() {
    this.loading = true
    const userData = {
      permission: {
        _id: this.permissionId,
        name: this.name,
      },
    }
    try {
      if (this.permission.name !== this.name) {
        await HttpRequestServiceWithToken.putByLevel(`${process.env.VUE_APP_API_URL}/v1`,  `permission/${this.permission._id}`, userData.permission)
        this.updateSnackbar({txt: 'แก้ไขสำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      }
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
